export const blockIconsActivitiesTheatersNew = (
	<span className='material-symbols-outlined'>theaters</span>
);
